<template>
	<r-standard-modal-form @closeModal="$emit('closeModal')">
		<span slot="title">Delete View?</span>
		<div slot="body" class="add-sheet-view-body">
			<div class="footer-text">
				Are you sure you’d like to delete {{sheetView.title}}? This cannot be undone.
			</div>
			<r-button theme="warn" fullWidth class="save-button" @click="deleteSheetView">
				Delete
			</r-button>
			<div class="cancel-button">
				<span class="cancel-button-text" @click="$emit('closeModal')">Cancel</span>
			</div>
		</div>
	</r-standard-modal-form>
</template>

<script>

// TODO: get choice array from imported Tab Type file
import CloudStore from 'js/cloudstore/cloudstore';

// using this below to send into the selectfield because it doesn't like using Null as a GUID.
const ADD_NEW_SVG =  'lkasjdjhgtlkasjh';

export default {
	name: 'delete-sheet-view-modal',
	$pubsub:{
		sheetViews:{
			
		}
	},
	data(){
		return {
		}
	},
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
	},
	computed:{

	},
	methods:{
		deleteSheetView(){

			const rvSelf = this;

			rvSelf.sheetView.delete();

			rvSelf.$nextTick(function afterTick(){
				rvSelf.$emit('closeModal');
			});
		},
	}

}

</script>

<style scoped lang="scss">

.save-button{
	width: 100%;
	margin-bottom: 24px;
}

.cancel-button{
	@include flex(row, center, center);

	.cancel-button-text{
		font-weight: 600;
		font-size: 14px;
		line-height: 21px;
		text-align: center;
		letter-spacing: 0.01em;
		color: $p-color-grey-500;

		@include clickable;
	}
}

.footer-text{
	margin: 15px 0 24px;

	font-weight: normal;
	font-size: 13px;
	line-height: 20px;
	/* or 154% */

	letter-spacing: 0.1px;

	color: $p-color-grey-500;
}

</style>